module.exports = __webpack_public_path__ + "img/home_image_2-mobile.211c79c5.png";